/**
 * @file Правила имени папки и общие ограничения для переименования.
 *
 * Проверка работает без React и сервера: пробелы по краям, служебные имена,
 * разделители пути, нулевой символ и конфликт с существующим именем.
 */
export type FolderErrorCode =
    | 'emptyName'
    | 'reservedName'
    | 'invalidName'
    | 'alreadyExists'
    | 'forbidden'
    | 'parentUnavailable'
    | 'unconfirmed'

export function validateFolderName(
    value: string,
    existingNames: ReadonlySet<string>,
): Extract<
    FolderErrorCode,
    'emptyName' | 'reservedName' | 'invalidName' | 'alreadyExists'
> | null {
    const name = value.trim()
    if (!name) return 'emptyName'

    if (name === '.' || name === '..') return 'reservedName'

    if (name.includes('/') || name.includes('\\') || name.includes('\0'))
        return 'invalidName'

    if (existingNames.has(name)) return 'alreadyExists'

    return null
}

export class CreateFolderError extends Error {
    readonly code: FolderErrorCode

    constructor(code: FolderErrorCode) {
        super(code)
        this.name = 'CreateFolderError'
        this.code = code
    }
}

export function getFolderErrorCode(error: unknown): FolderErrorCode {
    return error instanceof CreateFolderError ? error.code : 'unconfirmed'
}
